<script lang="ts" setup>
  import { reactiveOmit } from '@vueuse/core';
  import { ChevronLeft } from 'lucide-vue-next';
  import type { CalendarPrevProps } from 'reka-ui';
  import { CalendarPrev, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { buttonVariants } from '@ui/components/button';
  import { cn } from '@ui/utils/utils';

  const props = defineProps<CalendarPrevProps & { class?: HTMLAttributes['class'] }>();

  const delegatedProps = reactiveOmit(props, 'class');

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <CalendarPrev
    data-slot="calendar-prev-button"
    :class="
      cn(
        buttonVariants({ variant: 'outline' }),
        'size-6 bg-transparent p-0 opacity-50 hover:opacity-100',
        props.class,
      )
    "
    v-bind="forwardedProps"
  >
    <slot>
      <ChevronLeft class="size-4" />
    </slot>
  </CalendarPrev>
</template>
